/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_InactiveInputs */

const en__field_inactive = /** @type {(inputs: _Field_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

const de__field_inactive = /** @type {(inputs: _Field_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaktiv`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {_Field_InactiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_inactive = /** @type {((inputs?: _Field_InactiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_InactiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inactive(inputs)
	return de__field_inactive(inputs)
});